<div class="sales-dashboard-counter">
<mat-card class="even-more-blur">
  <mat-card-content>
    <div class="form-card">
      
      <h3>
        <i class="fa-solid fa-link" style="opacity: 0.9; color: #028da8;"></i>
        Referral Link
      </h3>

      <div class="empty-state">
        
        <div class="url-action-container">
          
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="url-input-field">
            <input matInput 
                   [(ngModel)]="referralUrl" 
                   (input)="sanitizeUrlInput($event)"
                   [disabled]="!isEditing"
                   placeholder="your-custom-link">

            <button mat-icon-button 
                    color="primary" 
                    matSuffix
                    (click)="toggleEdit()">
              <mat-icon>{{ isEditing ? 'check' : 'edit' }}</mat-icon> 
            </button>

            <mat-hint class="preview-url" *ngIf="referralUrl">horizinns.com/refer/{{ referralUrl }}</mat-hint>
          </mat-form-field>
          <button mat-icon-button 
                  color="primary" 
                  class="copy-button"
                  (click)="copyToClipboard()" 
                  [disabled]="!referralUrl || isEditing">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
        <a class="referral-help" (click)="referralHelp()">What is a referral link?</a>
      </div>
    </div>
  </mat-card-content>
</mat-card>
</div>